import * as React from 'react';

function PersonShareIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 25 25" fill="none" width="100%" height="100%" {...props}>
			<path
				d="M12.667.833c3.833 0 7 3 7 6.834 0 3.833-3.167 6.833-7 6.833C7 14.5 2.5 19 2.5 24.667H.833c0-5.333 3.333-9.667 8-11.167C7 12.167 5.667 10.167 5.667 7.667c0-3.833 3.167-6.834 7-6.834zM24.5 18l-4.167 4.333-1.166-1.166 2.333-2.5h-1.833a4.126 4.126 0 00-4.167 4.166v1.834h-1.667v-1.834c0-3.166 2.667-5.833 5.834-5.833h1.666l-2.166-2.333 1.166-1.167L24.5 18zM12.667 2.5c-3 0-5.334 2.334-5.334 5.167 0 2.833 2.334 5.166 5.334 5.166 3 0 5.333-2.333 5.333-5.166S15.667 2.5 12.667 2.5z"
				fill="currentColor"
			/>
			<defs>
				<clipPath id="prefix__prefix__clip0_27_2848">
					<path fill="currentColor" d="M0 0h25v25H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default PersonShareIcon;
